export default "__VITE_ASSET__BKacFNwn__"